import { Component } from '@angular/core';
import { NavController, NavParams, IonicPage,ViewController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import { SpotPage } from "../spot/spot";

@IonicPage({
  name: 'exhibition',
  segment: 'exhibition/:muzeum'
})
@Component({
  selector: 'page-exhibition',
  templateUrl: 'exhibition.html'
})
export class ExhibitionPage {
  id;
  bgImg=" ";
  exhibition;
  nosound =false;
  digits = ["·", "·", "·"];
  digitsIndex = 0;
  result;
  exhibitionNname="";
  spotName="";
  btnEnter="";
  codeTXT=":קוד מיקום";
  exhibitionColor ="";
  btnEnterShow=false;
  urlCode;
  lang;
  constructor(public navCtrl: NavController, public navParams: NavParams, private _DataProvider: DataProvider,    public viewCtrl: ViewController
    ) {
  //  this.id = this.navParams.get('id');

    this.urlCode = this.navParams.get('muzeum');
    this.id = this._DataProvider.getLocalStorage('exhibitionID');
    console.log(this.urlCode,this.id);
    this.lang = this._DataProvider.getLocalStorage('lang');
    if(this.lang == 'en'){
      this.codeTXT="Enter code : ";
    }
    // this._DataProvider.navigationC.home = false;
    // this._DataProvider.navigationC.more = false;
    // this._DataProvider.navigationC.numType = true;
  }


  dismiss(){
    this.viewCtrl.dismiss();

  }

  ionViewDidLoad() {
  //  this.exhibition = this._DataProvider.getExhibitionByID(this.id);
  this.id = localStorage.getItem('exhibitionID');
  console.log('this.id',this.id);
  this._DataProvider.showPad = false;

  console.log(this._DataProvider.ExhibitionsService);
   if(this.id){

 console.log('this.id',this.id);
  //  this._DataProvider.getExhibitionByID(this.id)
  //var res = this._DataProvider.getExhibitionByIDFB(this.id);
    
    
  //    console.log('res: --- ---- ',res);
      let self:any = this;

      // this._DataProvider.ExhibitionFBcol.doc(this.id).ref.get().then(function(doc) {
      //   if (doc.exists) {
      //       console.log("Document data:", doc.data());
      //       self.exhibition = doc.data();
      //       console.log(self.exhibition);
      //       console.log('self._DataProvider.Muzeum',self._DataProvider.Muzeum);
      //       self.bgImg = self._DataProvider.Muzeum.background;
      //       self.exhibitionNname = self.exhibition.name;
      //       self.btnEnter =  self.exhibition.btnEnter;
      //       self.exhibitionColor = self.exhibition.choosenColor;
      //       console.log(self.exhibition.codeTXT);
      //       if(self._DataProvider.Muzeum.hasOwnProperty('codeTXT')){
      //         console.log(self.exhibition.codeTXT);
      //         self.codeTXT = self._DataProvider.Muzeum.codeTXT;
      //       } 
      //       console.log(self.codeTXT);
      //   } else {
      //       console.log("No such document!");
      //   }
      // }).catch(function(error) {
      //     console.log("Error getting document:", error);
      // });




        
      }//end of if

  }

  clickOnBtnEnter(){
    console.log(this._DataProvider.selectedSpotExe);
    this.dismiss();
    this._DataProvider.setStatstic("go spot")

    this._DataProvider.setLocalStorage('selectedSpotID',this._DataProvider.selectedSpotExe);

    this._DataProvider.navToSpot.next({
      muzeum:this.urlCode,
      id:this._DataProvider.selectedSpot._id,
      exhibition:this.id,
    })


    // console.log(this._DataProvider.selectedSpotExe);
    // this.navCtrl.push(SpotPage, {
    //   muzeum:this.urlCode,
    //   id:this._DataProvider.selectedSpot._id,
    //   exhibition:this.id,

    // })

  }

  goToExlist(){
    console.log("goToExlist")
  }

  clickNum(numClicked) {
    var self = this;
    console.log('numClicked', numClicked);
    if (numClicked != 'delete') {
      // is a number
      console.log('digitsIndex', this.digitsIndex);
      if (this.digitsIndex == 2) {
        console.log('ask for data');
        this.digits[this.digitsIndex] = numClicked;
        this.digitsIndex++;
     
        //asking for data

        this._DataProvider.getSpotByExebitionCodeAndLangFB(this._DataProvider.Muzeum.id,this.digits[0].toString() +this.digits[1].toString() +this.digits[2].toString() ,this.lang)
        .subscribe(res => {
          console.log('result FB',res);
          this.result = res;
   
          console.log(this.result);
          if(this.result.length != 0){


            this._DataProvider.ExhibitionFBcol.doc(this.result[0]['ExhibitionsID']).ref.get().then(function(doc) {
              if (doc.exists) {
                  console.log("Document data:", doc.data());
                  self.exhibition = doc.data();
           
                  self.bgImg = self._DataProvider.Muzeum.background;
                  self.exhibitionNname = self.exhibition.name;
                  self.btnEnter =  self.exhibition.btnEnter;
                  self.exhibitionColor = self.exhibition.choosenColor;
                  self.nosound = self.exhibition.nosound;
                
              } else {
                  console.log("No such document!");
              }
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });






           this.bgImg=this.result[0]["bgImg"];
           this.spotName = this.result[0]["name"];
           this.btnEnterShow=true;
           this._DataProvider.selectedSpotExe = this.result[0]["id"];
           this._DataProvider.selectedSpot = this.result[0];
          }else{
            //do the not found here
            console.log("could not get !!");
          }


        });  
      //  this._DataProvider.getSpotByExebitionCodeAndLang(this._DataProvider.Muzeum._id,this.digits[0].toString() +this.digits[1].toString() +this.digits[2].toString() ,this.lang)
      //  .subscribe(res => {
      //     console.log(res);
      //     this.result = res["theResult"];
   
      //     console.log(this.result);
      //     if(this.result.length != 0){
      //      this.bgImg=this.result[0]["bgImg"];
      //      this.spotName = this.result[0]["name"];
      //      this.btnEnterShow=true;
      //      this._DataProvider.selectedSpotExe = this.result[0]["_id"];
      //      this._DataProvider.selectedSpot = this.result[0];
      //     }else{
      //       //do the not found here
      //       console.log("could not get !!");
      //     }

      //       });
      
      
   
    


      } else if (this.digitsIndex > 2) {
        console.log('no more -- light up the delete animation');
      } else {
        this.digits[this.digitsIndex] = numClicked;
        this.digitsIndex++;
      }//end of check index
    } else {
      // is delete
      console.log('digitsIndex', this.digitsIndex);
      if ( this.bgImg != this._DataProvider.Muzeum.background){
        console.log('this.bgImg !=');
        this.spotName = "";
        this._DataProvider.selectedSpot = {"id":"",_id:"",};
        this.btnEnterShow=false;
        this.bgImg = this._DataProvider.Muzeum.background;
      }


      if (this.digitsIndex != 0) {
        this.digitsIndex--;
        this.digits[this.digitsIndex] = "·";
      } 
      

    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/exhibition/exhibition.ts